import { QueryKeysEnum } from '@/enums';
import {
  CreateSettingEntity,
  LimitContentParams,
  SettingEntity,
} from '@/pages/privatePages/setting/types';
import APIService from './axios.service';
import { BaseService } from './base.service';

class SettingServiceClass extends BaseService<
  'adminSetting',
  SettingEntity,
  CreateSettingEntity
> {
  constructor() {
    super(QueryKeysEnum.ADMIN_SETTING);
  }

  limitContent = (params: LimitContentParams): Promise<any> => {
    return APIService.post(this.path + '/limit-content', params);
  };

  updateAdminSettings = (
    payload: Partial<SettingEntity>,
  ): Promise<SettingEntity> => {
    return APIService.patch(this.path, payload);
  };
}
export const settingService = new SettingServiceClass();
